
import React from 'react'
//import './carouselIndicator.css'

class CarouselIndicator extends React.Component {
  render() {
    const { active, count, onSwipeLeft, onSwipeRight } = this.props
    return (
      <div className="carousel-indicator collapse">
          <a onClick={onSwipeRight}>
            {active > 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-caret-left-fill" >
                <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
              </svg>
            ):(
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-caret-left">
                <path d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"/>
              </svg>
            )}
          </a>
        <ul className="carousel-indicator">
          {[...Array(count)].map((x,i) => <li className={i+1===active?"carousel-indicator active":"carousel-indicator"} key={i}/>)}
        </ul>
        <a onClick={onSwipeLeft}>
          {active !== count ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-caret-right-fill">
              <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
            </svg>
          ):(
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-caret-right-fill">
              <path d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"/>
            </svg>
          )}
        </a>
      </div>
    );
  }
}

export default CarouselIndicator



// WEBPACK FOOTER //
// ./src/components/common/CarouselIndicator.js